import { FEATURE_FLAGS_WEB } from "@next-platform/client-common-core/infra/constants";

/* eslint-disable no-barrel-files/no-barrel-files -- Barrel exports are required to preserve the constants. */
export * from "./api";
export * from "./assets";
export * from "./characters";
export * from "./common";
export * from "./errors";
export * from "./events";
export * from "./expiry";
export * from "./links";
export * from "./localStorage";
export * from "./lockedSubscribeFlow";
export * from "./navigation";
export * from "./permissions";
export * from "./persona";
export * from "./pricing";
export * from "./regions";
export * from "./sales";
export * from "./settings";
export * from "./subscriptions";
export * from "./tlds";
export * from "./user";
export * from "@next-platform/client-common-core/infra/constants/domains";
// Declared in the shared package: the backend stores two of these values on every queue record and
// publishes them in QueuePositionResponse, so the pair has to agree with this app.
export { QueueStatus } from "@next-platform/packages-ts-types";
export const FEATURE_FLAGS = FEATURE_FLAGS_WEB;
